/* eslint-disable react/prop-types */
import React from 'react';
import { RichText } from '../../core/RichText';
import useSurveyStyles from './useStyles';

export type Props = {
  text: string;
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const PageTitle: React.FC<Props> = ({ element = 'h2', text }) => {
  const { pageTitle } = useSurveyStyles();
  return <RichText element={element} text={text} className={pageTitle} />;
};

export default PageTitle;
